import React from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever,
} from "@mui/icons-material";

import { 
  Potence,
} from "@dndModels";
import { CHARACTER_LEVELS } from "@dndModels/Constants";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props {
  obj: Potence;
  onChange: (changed: Potence) => void;
  onDelete: () => void;
  disabled?: boolean;
}

export default function AbilityPotenceEnhanceItemInput({ 
  obj,
  onChange,
  onDelete,
  disabled = false
}: Props) {

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 4
        }}>
        { !disabled &&
          <Tooltip title={`Delete Potence`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        <SelectStringBox 
          options={CHARACTER_LEVELS}
          value={`${obj.level}`} 
          name="Level"
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.level = +changed;
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        <SelectObjectBox 
          name="Keyword Added"
          data_type="magic_item_keyword"
          values={ obj.enhance_ids }
          disabled={disabled}
          multiple
          display_format='{obj.use_name}'
          onChange={(changed: string[]) => {
            const new_obj = obj;
            new_obj.enhance_ids = changed;
            onChange(new_obj);
          }}
        /> 
      </Grid>
    </Grid>
  );
}
